
    import { Vue,Component,Watch } from 'vue-property-decorator'
    import { State,Action,namespace } from 'vuex-class'
    import moment from 'moment'
    const common = namespace('common')
    @Component
    export default class Home extends Vue{
        radio2:number = 6
        daterange:any = [(new Date()).getTime() - 3600 * 1000 * 24 * 7, new Date()]
        get chartData() {
            return{
                columns: ['日期','短信', '微信', '共计'],
                rows: this.smsList
            }
        }
        range:any = []
        @common.State('smsList') smsList:any
        @common.State('loading') loading:any
        
        get sum(){
            let re = 0
            this.smsList.map((item:any)=>{
                re = re + item['共计']
            })
            return re
        }
        get wxsum(){
            let re = 0
            this.smsList.map((item:any)=>{
                re = re + item['微信']
            })
            return re
        }
        @common.Action('getsmsList') getsmsList:any
        created(){
			this.onSubmit()
		}
        onSubmit(){
            this.getsmsList({
                star: moment(this.daterange[0]).format("YYYY-MM-DD"),
                end: moment(this.daterange[1]).format("YYYY-MM-DD")
            })
        }
        daterangechange(val:any){
            const end = new Date();
            const start = new Date();
            const daterange:any = [start, end]
            if (val == 6) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            }
            if (val == 9) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            }
            if (val == 12) {
                daterange[0] = start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            }
            this.daterange = daterange
        }
        @Watch('daterange')
        onDaterangeChanged(val: any, oldVal: any) {
            console.log(val);
            this.onSubmit()
        }
    }
